<script setup>
import { isEmpty } from "lodash";
import OpenIndicator from "./OpenIndicator.vue";

const props = defineProps({
    options: {
        type: [Object, Array],
    },
    label: {
        type: String,
        default: "",
    },
    default: {
        type: [Object, String],
    },
    placeholder: {
        type: String,
        default: "",
    },
    dataTest: {
        type: String,
        default: "select",
    },
    multiple: {
        type: Boolean,
        default: false,
    },
    error: {
        type: String,
        default: "",
    },
});

const emit = defineEmits(["change"]);
</script>

<template>
    <v-select
        class="select-component"
        :class="{
            'error-input-border-rounded': props.error
        }"
        :label="props.label"
        :data-test="dataTest"
        :components="{OpenIndicator}"
        :options="props.options"
        :placeholder="props.placeholder"
        :multiple="multiple"
        :clearable="false"
        @update:modelValue="emit('change', $event)"
        :modelValue="isEmpty(props.default) ? null : props.default"
    />
</template>

<style scoped>
.error-input-border-rounded {
    border: 1px solid #fb0100 !important;
    border-radius: 10px;
}

.select-component {
    margin-top: 0.7rem !important;
}

.vs__dropdown-menu > li {
    text-decoration: underline;
}
</style>
